import { FolkHolographicRC } from '../folk-holographic-rc';
FolkHolographicRC.define();
export { FolkHolographicRC };
//# sourceMappingURL=folk-holographic-rc.js.map